import { registerSW } from 'virtual:pwa-register'

let updateSW: ((reloadPage?: boolean) => Promise<void>) | undefined

export function registerAppSW() {
  updateSW = registerSW({
    immediate: true,

    onNeedRefresh() {
      window.dispatchEvent(new CustomEvent('app:update-ready'))
    },

    onOfflineReady() {
      console.info('App prête hors ligne')
    },
  })
}

export async function activateUpdateWhenSafe() {
  if (!updateSW) return

  // Ici, true recharge la page.
  // À appeler uniquement quand vous décidez que le contexte est sûr.
  await updateSW(true)
}

export function isUpdateAvailable(): boolean {
  return updateSW !== undefined
}
